// extracted by mini-css-extract-plugin
export default {"hero_container":"q5","hero_pic_container":"r5","hero_pic":"s5","hero_data_container":"t5","hero_data":"u5","hero_title":"v5","hero_text":"w5","hero_bottom_btn":"x5","hero_bottom_arrow":"y5"};
    if(module.hot) {
      // 1738836198820
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  